export type MediaType = 'movie' | 'tv';

export interface Media {
  id: string;
  title: string;
  type: MediaType;
  genres: string[];
  region: string;
  year: number;
  rating: number;
  duration: string;
  director: string;
  cast: string[];
  cover: string;
  backdrop?: string;
  description: string;
  tags: string[];
  views: number;
  updatedAt: string;
}

export const MEDIA_LIST: Media[] = [
  {
    id: 'm01',
    title: '深空回响',
    type: 'movie',
    genres: ['科幻', '动作'],
    region: '美国',
    year: 2026,
    rating: 8.7,
    duration: '142分钟',
    director: 'Ethan Cole',
    cast: ['Marcus Reed', 'Lena Ortiz', 'David Park'],
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%2C%20deep%20space%20nebula%2C%20lone%20astronaut%20silhouette%2C%20deep%20blue%20tones%20with%20amber%20rim%20light%2C%20dramatic%20moody%20atmosphere%2C%20high%20detail%2C%20vertical%20composition&width=600&height=900&seq=pmy-cover-01&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20space%20scene%20with%20glowing%20nebula%20and%20distant%20planet%2C%20deep%20navy%20blue%20palette%20with%20warm%20golden%20light%20accents%2C%20cinematic%20wide%20shot%2C%20atmospheric%20haze%2C%20ultra%20detailed&width=1920&height=1000&seq=pmy-hero-01&orientation=landscape',
    description: '一支深空探险队在未知星系捕捉到神秘信号，随着调查深入，他们发现了足以颠覆人类认知的真相。影片以宏大的宇宙视野与紧张节奏，呈现一场关于勇气与牺牲的星际旅程。',
    tags: ['科幻史诗', '太空冒险', '视觉震撼'],
    views: 1286000,
    updatedAt: '2026-10-12',
  },
  {
    id: 'm02',
    title: '城市之光',
    type: 'movie',
    genres: ['剧情', '犯罪'],
    region: '香港',
    year: 2025,
    rating: 8.2,
    duration: '118分钟',
    director: '陈志远',
    cast: ['梁正宇', '周若彤', '何家俊'],
    cover: 'https://readdy.ai/api/search-image?query=Neo-noir%20crime%20movie%20poster%2C%20rainy%20neon%20city%20street%20at%20night%2C%20lone%20figure%20with%20umbrella%2C%20deep%20blue%20and%20amber%20lights%2C%20cinematic%20mood%2C%20vertical%20composition&width=600&height=900&seq=pmy-cover-02&orientation=portrait',
    description: '一名坚守底线的老刑警与初出茅庐的年轻搭档，在霓虹闪烁的都市中追查一桩跨越十年的悬案。真相背后，是人性的挣扎与城市的冷暖。',
    tags: ['港式警匪', '悬疑追凶', '都市人性'],
    views: 942000,
    updatedAt: '2026-10-09',
  },
  {
    id: 'm03',
    title: '春风十里',
    type: 'tv',
    genres: ['爱情', '剧情'],
    region: '大陆',
    year: 2026,
    rating: 7.9,
    duration: '全32集',
    director: '林清和',
    cast: ['苏晚晴', '顾承轩', '白若曦'],
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20drama%20TV%20poster%2C%20young%20couple%20under%20spring%20blossom%20trees%2C%20soft%20warm%20light%2C%20gentle%20pastel%20tones%2C%20dreamy%20bokeh%2C%20vertical%20composition&width=600&height=900&seq=pmy-cover-03&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Soft%20spring%20countryside%20with%20blooming%20flowers%20and%20warm%20sunlight%2C%20couple%20walking%20hand%20in%20hand%2C%20romantic%20golden%20hour%20glow%2C%20cinematic%20wide%20shot&width=1920&height=1000&seq=pmy-hero-03&orientation=landscape',
    description: '两个性格迥异的都市青年，在一座慢节奏的小城相遇相知。从误解到理解，从分别到重逢，一段温暖治愈的爱情故事在春风中缓缓展开。',
    tags: ['都市爱情', '治愈系', '高颜值'],
    views: 1562000,
    updatedAt: '2026-10-14',
  },
  {
    id: 'm04',
    title: '迷雾追凶',
    type: 'tv',
    genres: ['悬疑', '犯罪'],
    region: '韩国',
    year: 2025,
    rating: 9.1,
    duration: '全16集',
    director: 'Kim Ji-han',
    cast: ['Park Seo-yeon', 'Lee Jun-ho', 'Choi Min-a'],
    cover: 'https://readdy.ai/api/search-image?query=Dark%20thriller%20TV%20series%20poster%2C%20foggy%20forest%20road%2C%20detective%20with%20flashlight%2C%20cold%20blue%20atmosphere%2C%20suspense%20mood%2C%20vertical%20composition&width=600&height=900&seq=pmy-cover-04&orientation=portrait',
    description: '连续失踪案让小镇笼罩在恐惧之中，一位被停职的警探独自展开调查。层层迷雾之下，凶手或许就藏在最亲近的人中间。',
    tags: ['高分悬疑', '烧脑推理', '韩剧'],
    views: 1873000,
    updatedAt: '2026-10-13',
  },
  {
    id: 'm05',
    title: '幻域奇缘',
    type: 'movie',
    genres: ['奇幻', '动画'],
    region: '日本',
    year: 2026,
    rating: 8.9,
    duration: '126分钟',
    director: 'Hayao Sato',
    cast: ['配音阵容：花泽绫', '中村莲'],
    cover: 'https://readdy.ai/api/search-image?query=Anime%20fantasy%20film%20poster%2C%20floating%20islands%20and%20magical%20creatures%2C%20young%20hero%20with%20glowing%20companion%2C%20vivid%20but%20harmonious%20palette%2C%20vertical%20composition&width=600&height=900&seq=pmy-cover-05&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Anime%20style%20fantasy%20landscape%20with%20floating%20islands%20and%20waterfalls%2C%20warm%20golden%20clouds%2C%20dreamy%20adventure%20atmosphere%2C%20cinematic%20wide%20shot&width=1920&height=1000&seq=pmy-hero-05&orientation=landscape',
    description: '一个能听见风之语言的少女，为寻找失踪的兄长踏上穿越幻域的旅程。沿途结识的伙伴与奇幻生物，共同编织出一段成长的童话。',
    tags: ['动画电影', '奇幻冒险', '宫崎风'],
    views: 1105000,
    updatedAt: '2026-10-08',
  },
  {
    id: 'm06',
    title: '终极护卫',
    type: 'movie',
    genres: ['动作', '犯罪'],
    region: '美国',
    year: 2025,
    rating: 7.6,
    duration: '134分钟',
    director: 'Ryan West',
    cast: ['Jason Blake', 'Nina Ford', 'Carlos Mendes'],
    cover: 'https://readdy.ai/api/search-image?query=Action%20thriller%20movie%20poster%2C%20bodyguard%20in%20suit%20walking%20away%20from%20explosion%2C%20deep%20blue%20night%20city%2C%20dramatic%20lighting%2C%20vertical%20composition&width=600&height=900&seq=pmy-cover-06&orientation=portrait',
    description: '退役特工受命保护一名掌握关键证据的证人，一场横跨三座城市的追杀随之展开。动作场面酣畅淋漓，情节环环相扣。',
    tags: ['硬核动作', '保镖题材', '爆米花'],
    views: 876000,
    updatedAt: '2026-10-05',
  },
  {
    id: 'm07',
    title: '山海奇谭',
    type: 'tv',
    genres: ['奇幻', '古装'],
    region: '大陆',
    year: 2026,
    rating: 8.4,
    duration: '全40集',
    director: '程墨白',
    cast: ['江予墨', '沈知微', '陆长风'],
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20costume%20drama%20poster%2C%20immortal%20in%20flowing%20robes%20before%20misty%20mountains%2C%20ink%20painting%20aesthetic%2C%20deep%20blue%20and%20ink%20tones%2C%20vertical%20composition&width=600&height=900&seq=pmy-cover-07&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20misty%20mountain%20range%20with%20clouds%20and%20a%20distant%20temple%2C%20ink%20wash%20painting%20aesthetic%2C%20deep%20blue%20and%20soft%20amber%20light%2C%20cinematic%20wide%20shot&width=1920&height=1000&seq=pmy-hero-07&orientation=landscape',
    description: '上古神兽重现人间，凡尘少年意外继承守护之责。在仙门争斗与家国大义之间，他必须做出改变命运的抉择。',
    tags: ['东方奇幻', '仙侠', '特效大片'],
    views: 1420000,
    updatedAt: '2026-10-11',
  },
  {
    id: 'm08',
    title: '笑傲日常',
    type: 'tv',
    genres: ['喜剧', '家庭'],
    region: '大陆',
    year: 2025,
    rating: 8.0,
    duration: '全24集',
    director: '王乐天',
    cast: ['彭一飞', '赵小满', '孙大川'],
    cover: 'https://readdy.ai/api/search-image?query=Light%20hearted%20comedy%20TV%20poster%2C%20happy%20family%20in%20colorful%20living%20room%2C%20bright%20cheerful%20tones%2C%20playful%20mood%2C%20vertical%20composition&width=600&height=900&seq=pmy-cover-08&orientation=portrait',
    description: '一个鸡飞狗跳的大家庭，每天都在上演令人捧腹的日常。笑点密集又温暖治愈，适合全家一起观看。',
    tags: ['家庭喜剧', '下饭剧', '温馨'],
    views: 720000,
    updatedAt: '2026-10-03',
  },
  {
    id: 'm09',
    title: '黑夜使者',
    type: 'movie',
    genres: ['悬疑', '惊悚'],
    region: '英国',
    year: 2025,
    rating: 8.3,
    duration: '110分钟',
    director: 'Oliver Hart',
    cast: ['Emma Clarke', 'Thomas Reed', 'Sophie Lane'],
    cover: 'https://readdy.ai/api/search-image?query=Gothic%20mystery%20movie%20poster%2C%20lone%20lamp%20in%20dark%20foggy%20street%2C%20silhouette%20figure%2C%20deep%20blue%20noir%20tones%2C%20eerie%20atmosphere%2C%20vertical%20composition&width=600&height=900&seq=pmy-cover-09&orientation=portrait',
    description: '每当夜幕降临，城市便出现神秘的涂鸦预言。一位记者顺藤摸瓜，揭开了一个关于记忆与身份的惊人秘密。',
    tags: ['英伦悬疑', '心理惊悚', '反转'],
    views: 654000,
    updatedAt: '2026-10-06',
  },
  {
    id: 'm10',
    title: '青春纪事',
    type: 'tv',
    genres: ['爱情', '青春'],
    region: '台湾',
    year: 2026,
    rating: 7.8,
    duration: '全20集',
    director: '陈映桦',
    cast: ['林思瑶', '林彦廷', '吴雨柔'],
    cover: 'https://readdy.ai/api/search-image?query=Coming%20of%20age%20youth%20drama%20poster%2C%20students%20on%20campus%20with%20sunset%20backlight%2C%20nostalgic%20warm%20tones%2C%20soft%20grain%2C%20vertical%20composition&width=600&height=900&seq=pmy-cover-10&orientation=portrait',
    description: '一段发生在盛夏校园的青春故事，关于友谊、暗恋与成长。那些没能说出口的心事，最终都随风写进了纪念册。',
    tags: ['校园青春', '初恋', '怀旧'],
    views: 810000,
    updatedAt: '2026-10-10',
  },
  {
    id: 'm11',
    title: '星际远征',
    type: 'movie',
    genres: ['科幻', '冒险'],
    region: '美国',
    year: 2026,
    rating: 9.0,
    duration: '150分钟',
    director: 'Nora Bennett',
    cast: ['Chris Vance', 'Aisha Rahman', 'Leo Grant'],
    cover: 'https://readdy.ai/api/search-image?query=Space%20adventure%20movie%20poster%2C%20sleek%20starship%20approaching%20giant%20planet%2C%20deep%20blue%20cosmos%20with%20amber%20engine%20glow%2C%20epic%20scale%2C%20vertical%20composition&width=600&height=900&seq=pmy-cover-11&orientation=portrait',
    description: '人类的第一艘远航方舟驶向新家园，漫长的太空旅途中，船员们面对的不只是未知的宇宙，还有内心深处的孤独与信念。',
    tags: ['太空史诗', '硬科幻', 'IMAX级'],
    views: 1990000,
    updatedAt: '2026-10-15',
  },
  {
    id: 'm12',
    title: '黄河绝恋',
    type: 'movie',
    genres: ['战争', '爱情'],
    region: '大陆',
    year: 2024,
    rating: 8.5,
    duration: '128分钟',
    director: '张承海',
    cast: ['李牧原', '柳如烟', '冯国强'],
    cover: 'https://readdy.ai/api/search-image?query=Historical%20war%20romance%20movie%20poster%2C%20figures%20by%20the%20Yellow%20River%20at%20dusk%2C%20muted%20deep%20blue%20and%20amber%20tones%2C%20epic%20somber%20mood%2C%20vertical%20composition&width=600&height=900&seq=pmy-cover-12&orientation=portrait',
    description: '战火纷飞的年代，一名译电员与一位当地女子相识于黄河岸边。在生死抉择面前，他们用各自的方式守护着心中的家国与爱。',
    tags: ['战争史诗', '家国情怀', '催泪'],
    views: 758000,
    updatedAt: '2026-09-28',
  },
  {
    id: 'm13',
    title: '都市猎人',
    type: 'tv',
    genres: ['动作', '犯罪'],
    region: '香港',
    year: 2025,
    rating: 8.1,
    duration: '全28集',
    director: '黄伟峰',
    cast: ['郑浩南', '林晓彤', '马志强'],
    cover: 'https://readdy.ai/api/search-image?query=Urban%20action%20crime%20series%20poster%2C%20stylish%20cop%20on%20rooftop%20overlooking%20city%2C%20neon%20deep%20blue%20night%2C%20cool%20mood%2C%20vertical%20composition&width=600&height=900&seq=pmy-cover-13&orientation=portrait',
    description: '一支专门对付高智商犯罪的特别行动组，用游走于规则边缘的方式维护正义。每个案件都暗藏人性的考验。',
    tags: ['警匪剧', '快节奏', '港产'],
    views: 903000,
    updatedAt: '2026-10-07',
  },
  {
    id: 'm14',
    title: '月光信笺',
    type: 'movie',
    genres: ['爱情', '剧情'],
    region: '法国',
    year: 2025,
    rating: 8.6,
    duration: '115分钟',
    director: 'Julien Mercier',
    cast: ['Claire Dubois', 'Antoine Laurent'],
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20European%20film%20poster%2C%20woman%20reading%20letters%20by%20moonlit%20window%2C%20soft%20warm%20amber%20glow%2C%20dreamy%20melancholic%20mood%2C%20vertical%20composition&width=600&height=900&seq=pmy-cover-14&orientation=portrait',
    description: '一封迟到了二十年的信，让两位老人重新走进彼此的生命。影片以细腻的笔触，讲述关于遗憾、等待与重逢的温柔故事。',
    tags: ['文艺爱情', '法式浪漫', '慢节奏'],
    views: 512000,
    updatedAt: '2026-09-30',
  },
  {
    id: 'm15',
    title: '深海秘境',
    type: 'movie',
    genres: ['动画', '冒险'],
    region: '日本',
    year: 2025,
    rating: 8.8,
    duration: '108分钟',
    director: 'Kenta Mori',
    cast: ['配音阵容：小野遥', '佐藤健司'],
    cover: 'https://readdy.ai/api/search-image?query=Anime%20underwater%20adventure%20poster%2C%20child%20and%20glowing%20sea%20creature%2C%20deep%20blue%20ocean%20with%20warm%20light%20rays%2C%20wonder%20mood%2C%20vertical%20composition&width=600&height=900&seq=pmy-cover-15&orientation=portrait',
    description: '一个热爱海洋的少年，在潜水时遇见会发光的奇异生物，由此开启一段探索深海秘境的奇幻旅程，也重新认识了亲情与勇气。',
    tags: ['治愈动画', '海洋冒险', '合家欢'],
    views: 689000,
    updatedAt: '2026-10-02',
  },
  {
    id: 'm16',
    title: '权谋之巅',
    type: 'tv',
    genres: ['剧情', '历史'],
    region: '大陆',
    year: 2026,
    rating: 8.7,
    duration: '全45集',
    director: '高junjie',
    cast: ['萧景琰', '江晚晴', '慕容天'],
    cover: 'https://readdy.ai/api/search-image?query=Historical%20political%20drama%20poster%2C%20emperor%20on%20throne%20in%20grand%20hall%2C%20deep%20blue%20and%20gold%20tones%2C%20solemn%20epic%20mood%2C%20vertical%20composition&width=600&height=900&seq=pmy-cover-16&orientation=portrait',
    description: '朝堂之上暗流涌动，一场围绕皇权的博弈悄然拉开。忠臣、权相、敌国使者各怀心思，步步惊心的权谋对决一触即发。',
    tags: ['历史权谋', '烧脑', '大制作'],
    views: 1670000,
    updatedAt: '2026-10-14',
  },
  {
    id: 'm17',
    title: '危机72小时',
    type: 'movie',
    genres: ['动作', '惊悚'],
    region: '韩国',
    year: 2026,
    rating: 7.7,
    duration: '122分钟',
    director: 'Jung Ha-neul',
    cast: ['Kim Do-yun', 'Han So-mi', 'Baek Jun'],
    cover: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20movie%20poster%2C%20countdown%20clock%20over%20city%20skyline%2C%20tension%20deep%20blue%20tones%20with%20red%20amber%20accents%2C%20vertical%20composition&width=600&height=900&seq=pmy-cover-17&orientation=portrait',
    description: '一场精心策划的危机在都市核心引爆，谈判专家必须在72小时内阻止灾难。时间一分一秒流逝，真凶的身份却出人意料。',
    tags: ['犯罪惊悚', '倒计时', '韩影'],
    views: 623000,
    updatedAt: '2026-10-13',
  },
  {
    id: 'm18',
    title: '云上牧歌',
    type: 'tv',
    genres: ['剧情', '治愈'],
    region: '大陆',
    year: 2025,
    rating: 8.2,
    duration: '全26集',
    director: '叶轻舟',
    cast: ['苏牧云', '阿依古丽', '周牧野'],
    cover: 'https://readdy.ai/api/search-image?query=Healing%20rural%20drama%20poster%2C%20grassland%20with%20sheep%20under%20wide%20sky%2C%20soft%20natural%20light%2C%20peaceful%20pastoral%20mood%2C%20vertical%20composition&width=600&height=900&seq=pmy-cover-18&orientation=portrait',
    description: '城市青年回到草原牧场，在慢节奏的生活中重新找回自我。蓝天白云、牧歌悠扬，一部让人安静下来的治愈之作。',
    tags: ['田园治愈', '慢生活', '风景美'],
    views: 566000,
    updatedAt: '2026-10-01',
  },
  {
    id: 'm19',
    title: '记忆碎片',
    type: 'movie',
    genres: ['悬疑', '科幻'],
    region: '美国',
    year: 2025,
    rating: 8.9,
    duration: '130分钟',
    director: 'Alex Turner',
    cast: ['Ryan Holt', 'Mia Santo', 'Owen Cook'],
    cover: 'https://readdy.ai/api/search-image?query=Psychological%20sci-fi%20thriller%20poster%2C%20fragmented%20face%20and%20glitch%20patterns%2C%20deep%20blue%20and%20cyan%20tones%20with%20amber%20highlights%2C%20vertical%20composition&width=600&height=900&seq=pmy-cover-19&orientation=portrait',
    description: '一种可以编辑记忆的技术问世后，一名男子发现自己的过去被人为篡改。为了找回真相，他必须在自己都不可信的回忆里穿行。',
    tags: ['烧脑神作', '记忆科幻', '多重反转'],
    views: 1345000,
    updatedAt: '2026-10-12',
  },
  {
    id: 'm20',
    title: '江湖再起',
    type: 'tv',
    genres: ['武侠', '古装'],
    region: '大陆',
    year: 2026,
    rating: 8.3,
    duration: '全38集',
    director: '古长风',
    cast: ['萧逸尘', '苏轻雪', '独孤鸣'],
    cover: 'https://readdy.ai/api/search-image?query=Wuxia%20martial%20arts%20drama%20poster%2C%20swordsman%20on%20cliff%20in%20bamboo%20forest%2C%20misty%20deep%20blue%20and%20ink%20tones%2C%20dynamic%20mood%2C%20vertical%20composition&width=600&height=900&seq=pmy-cover-20&orientation=portrait',
    description: '失传已久的武林秘笈重出江湖，各方势力为之蠢蠢欲动。一位背负血海深仇的少侠踏上复仇之路，却在途中明白了侠之大者的真义。',
    tags: ['武侠江湖', '快意恩仇', '打戏精彩'],
    views: 1188000,
    updatedAt: '2026-10-11',
  },
  {
    id: 'm21',
    title: '欢闹一家亲',
    type: 'tv',
    genres: ['喜剧', '家庭'],
    region: '美国',
    year: 2025,
    rating: 7.5,
    duration: '全22集',
    director: 'Mark Fisher',
    cast: ['Tom Bailey', 'Grace Miller', 'Lily Adams'],
    cover: 'https://readdy.ai/api/search-image?query=Sitcom%20family%20poster%2C%20quirky%20family%20group%20portrait%20in%20suburban%20home%2C%20bright%20playful%20warm%20tones%2C%20vertical%20composition&width=600&height=900&seq=pmy-cover-21&orientation=portrait',
    description: '一对新手父母加上两个捣蛋鬼，还要应付随时来访的长辈。混乱又欢乐的日常，让这个家永远热闹非凡。',
    tags: ['美式喜剧', '合家欢', '轻松'],
    views: 480000,
    updatedAt: '2026-09-29',
  },
  {
    id: 'm22',
    title: '追风少年',
    type: 'movie',
    genres: ['运动', '励志'],
    region: '印度',
    year: 2025,
    rating: 8.4,
    duration: '146分钟',
    director: 'Arjun Nair',
    cast: ['Rahul Mehta', 'Priya Sharma'],
    cover: 'https://readdy.ai/api/search-image?query=Sports%20inspirational%20movie%20poster%2C%20young%20runner%20sprinting%20on%20track%20at%20dawn%2C%20warm%20golden%20light%2C%20triumphant%20energy%2C%20vertical%20composition&width=600&height=900&seq=pmy-cover-22&orientation=portrait',
    description: '出身贫寒的少年怀揣田径梦想，在质疑与伤病中一路奔跑。他用汗水证明，真正的对手从来只有自己。',
    tags: ['励志燃片', '运动题材', '催泪'],
    views: 702000,
    updatedAt: '2026-10-04',
  },
  {
    id: 'm23',
    title: '荒漠行者',
    type: 'movie',
    genres: ['冒险', '西部'],
    region: '美国',
    year: 2024,
    rating: 8.0,
    duration: '120分钟',
    director: 'Samuel Reed',
    cast: ['Jack Monroe', 'Elena Vasquez'],
    cover: 'https://readdy.ai/api/search-image?query=Western%20adventure%20movie%20poster%2C%20lone%20rider%20in%20vast%20desert%20canyon%2C%20warm%20amber%20and%20deep%20blue%20sky%2C%20lone%20dramatic%20mood%2C%20vertical%20composition&width=600&height=900&seq=pmy-cover-23&orientation=portrait',
    description: '一名独行者在荒芜的西部大地寻找传说中的绿洲。漫漫黄沙中，他不仅要对抗自然，还要面对穷追不舍的旧日宿敌。',
    tags: ['西部片', '冒险', '硬派'],
    views: 445000,
    updatedAt: '2026-09-26',
  },
  {
    id: 'm24',
    title: '花开时节',
    type: 'tv',
    genres: ['剧情', '爱情'],
    region: '韩国',
    year: 2026,
    rating: 8.6,
    duration: '全16集',
    director: 'Seo Yeon-ah',
    cast: ['Jang Hye-jin', 'Oh Seung-min'],
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20Korean%20drama%20poster%2C%20couple%20in%20field%20of%20flowers%20at%20golden%20hour%2C%20soft%20warm%20pastel%20tones%2C%20tender%20mood%2C%20vertical%20composition&width=600&height=900&seq=pmy-cover-24&orientation=portrait',
    description: '两位曾错过彼此的年轻人，在一座开满鲜花的小镇重逢。这一次，他们决定不再放开彼此的手。',
    tags: ['韩式爱情', '治愈', '高甜'],
    views: 1056000,
    updatedAt: '2026-10-13',
  },
];

export const GENRES: string[] = ['动作', '喜剧', '爱情', '科幻', '悬疑', '剧情', '惊悚', '动画', '犯罪', '奇幻', '战争', '武侠', '青春', '冒险', '历史', '运动', '家庭', '治愈', '西部'];

export const REGIONS: string[] = ['大陆', '香港', '台湾', '美国', '韩国', '日本', '英国', '法国', '印度'];

export const YEARS: number[] = [2026, 2025, 2024, 2023, 2022, 2021, 2020, 2019, 2018];

export const HOT_KEYWORDS: string[] = ['最新电影', '悬疑剧', '科幻大片', '韩剧爱情', '动作惊悚', '治愈系'];

export function findMediaById(id: string): Media | undefined {
  return MEDIA_LIST.find((item) => item.id === id);
}

export function getRelated(media: Media, count = 6): Media[] {
  return MEDIA_LIST
    .filter((item) => item.id !== media.id)
    .map((item) => {
      let score = 0;
      if (item.type === media.type) score += 1;
      const sharedGenres = item.genres.filter((g) => media.genres.includes(g)).length;
      score += sharedGenres * 3;
      if (item.region === media.region) score += 1;
      return { item, score };
    })
    .sort((a, b) => b.score - a.score || b.item.rating - a.item.rating)
    .slice(0, count)
    .map((entry) => entry.item);
}